import styled from 'styled-components';

export const Container = styled.div`
  .section-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
    margin: 0 0 16px;
  }

  .month-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
    margin: 24px 0 16px;
  }

  .empty-state {
    text-align: center;
    color: #888;
    padding: 60px 20px;
  }

  .empty-state .material-icons {
    font-size: 56px;
    color: #ccc;
    margin-bottom: 12px;
  }

  .loading-wrapper {
    display: flex;
    justify-content: center;
    padding: 60px 0;
  }
`;
